import gql from "graphql-tag";
import apolloGetQuery from "application/apollo/apolloGetQuery";
import getSearchForm from "application/queries/form/searchForm";
import { getHeaders } from "application/functions";

const searchForm = (id) =>
  apolloGetQuery(
    {
      query: gql`
      {
        ${getSearchForm(id)}
      }
    `,
    },
    getHeaders()
  );

export default {
  searchForm,
};
